module.exports = __webpack_public_path__ + "img/16.ac0a7b97.png";